export const VIEW_MODE = {
  PHOTOS: 'photos',
  DUPLICATES: 'duplicates',
  DEBUG: 'debug',
};
